export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/homeHero-a74195949baefe336eec1d180ec64942.svg";